import { useTranslation } from "react-i18next";

import { PageError } from "../components/PageError";
import { PageWrapper } from "../components/PageWrapper";
import { COMMON_TRANSLATION_KEYS } from "../constants/commonTranslationsKeys";

import type { ReactNode } from "react";

export interface Page404Props {
  buttonLabel?: ReactNode;
  description?: ReactNode;
  goBackLink?: string;
  title?: ReactNode;
}

export function Page404({
  buttonLabel,
  description,
  goBackLink,
  title,
}: Page404Props) {
  const { t } = useTranslation("common");

  return (
    <PageWrapper>
      <PageError
        title={title ?? t(COMMON_TRANSLATION_KEYS.notFoundError)}
        description={
          description ?? t(COMMON_TRANSLATION_KEYS.sorryPageNotFound)
        }
        goBackLink={goBackLink ?? "/"}
        buttonLabel={
          buttonLabel ?? t(COMMON_TRANSLATION_KEYS.returnToDashboard)
        }
      />
    </PageWrapper>
  );
}
